// @flow
import React from "react";

import SectionHeader from "./commons/SectionHeader";
import Section from "./commons/Section";
import CoverPic from "./commons/CoverPic";
import { THEME_LINK_STYLE } from "./commons/theme";

const PIC_STYLE = { flex: 1 };

const References = () => {
  return (
    <div style={{}}>
      <SectionHeader>Nos références</SectionHeader>
      <Section>
        <div style={{ textAlign: "justify", margin: 20 }}>
          On parle de nous :
          <ul>
            <li>
              Sélection dans le guide{" "}
              <a
                style={{ fontWeight: "bold" }}
                href="https://fr.gaultmillau.com/wineries/de-villepin"
              >
                Gault et Millau
              </a>{" "}
              depuis 2021
            </li>
            <li>
              Sélection{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={THEME_LINK_STYLE}
                href="http://patrick.dussert-gerber.com/archives/champagne-les-degustations-du-prochain-guide-commencent.html"
              >
                Guide Dussert Gerber 2024
              </a>
            </li>
            <li>
              Article{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={THEME_LINK_STYLE}
                href="https://www.larvf.com/pour-les-fetes-33-champagnes-de-vignerons-a-moins-de-30-euros-a-ne-pas-manquer,4842447.asp"
              >
                La Revue du Vin de France (décembre 2023)
              </a>
            </li>
          </ul>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
            textAlign: "center",
          }}
        >
          <div style={PIC_STYLE}>
            <img
              src="viticulutredurable.png"
              alt="Label viticulture durable"
              style={{ width: 200, height: 200 }}
            />
          </div>
          <div style={PIC_STYLE}>
            <img
              src="hautevaleurenvironnementale.png"
              alt="label haute valeur environnementale"
              style={{ width: 200, height: 200 }}
            />
          </div>
          {/* <div style={PIC_STYLE}>
            <img
              src="prixplaisir.png"
              alt="Médaille d'or Prix Plaisir Bettane+Desseauve 2019"
              style={{ width: 200, height: 200 }}
            />
          </div> */}
          <div style={PIC_STYLE}>
            <img
              src="gaultmillau.png"
              alt="Guide Gault et Millau 2021"
              style={{ width: 200, height: 200 }}
            />
          </div>
        </div>
        <div style={{ marginTop: 50, textAlign: "center" }}>
          <img
            src="logoab_eurofeuille_biologique.png"
            alt="Certification Bio"
            style={{ width: "100%", maxWidth: 500 }}
          />
          <p style={{ margin: 0 }}>Certifié par FR-BIO-20</p>
        </div>
      </Section>
      {/* <CoverPic src="vignes_pluie.jpg" /> */}
    </div>
  );
};

export default References;



// WEBPACK FOOTER //
// ./src/References.js